// The indicators API flags a day it has no value for yet (typically yesterday,
// before it is processed) with -999. Read as a number it became a real reading:
// it stretched the chart axes (a 0-2.6 in rain axis went to 105 in), was
// subtracted from accumulated totals and won the period minimum. Turn it into null.
const NODATA_THRESHOLD = -999;

export function withoutNoData(rows) {
    if (!Array.isArray(rows)) return rows;
    return rows.map(row => {
        if (!row || typeof row !== 'object') return row;
        let clean = row;
        Object.keys(row).forEach(key => {
            const value = row[key];
            if (typeof value === 'number' && value <= NODATA_THRESHOLD) {
                if (clean === row) clean = { ...row };
                clean[key] = null;
            }
        });
        return clean;
    });
}
